import React, { useState } from 'react';
import { XIcon, HistoryIcon, CheckIcon, ClockIcon } from 'lucide-react';
interface PreviousCoding {
  glCode: string;
  description: string;
  usedDate: string;
  invoiceNumber: string;
  useCount: number;
}
interface PreviousCodingModalProps {
  vendor: string;
  lineItemCount: number;
  onApply: (glCode: string) => void;
  onClose: () => void;
}
// Mock previous coding data
const MOCK_PREVIOUS_CODINGS: PreviousCoding[] = [{
  glCode: '6100-1000',
  description: 'Office Supplies - General',
  usedDate: '2024-01-10',
  invoiceNumber: 'INV-2024-001',
  useCount: 15
}, {
  glCode: '6200-1000',
  description: 'Professional Services - Consulting',
  usedDate: '2024-01-08',
  invoiceNumber: 'INV-2024-002',
  useCount: 8
}, {
  glCode: '6300-1000',
  description: 'IT Equipment - Hardware',
  usedDate: '2024-01-05',
  invoiceNumber: 'INV-2024-003',
  useCount: 5
}];
export function PreviousCodingModal({
  vendor,
  lineItemCount,
  onApply,
  onClose
}: PreviousCodingModalProps) {
  const [selectedCode, setSelectedCode] = useState('');
  const handleApply = () => {
    if (selectedCode) {
      onApply(selectedCode);
    }
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-6767">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[80vh] overflow-hidden flex flex-col" data-id="element-6768">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200" data-id="element-6769">
          <div className="flex items-center gap-3 mb-2" data-id="element-6770">
            <div className="p-2 bg-purple-100 rounded-lg" data-id="element-6771">
              <HistoryIcon className="w-5 h-5 text-purple-600" data-id="element-6772" />
            </div>
            <div data-id="element-6773">
              <h2 className="text-lg font-semibold text-gray-900" data-id="element-6774">
                Previous Coding
              </h2>
              <p className="text-sm text-gray-600" data-id="element-6775">
                Select from previously used GL codes for {vendor}
              </p>
            </div>
          </div>
        </div>

        {/* Previous Codings List */}
        <div className="flex-1 overflow-y-auto p-4" data-id="element-6776">
          <div className="space-y-2" data-id="element-6777">
            {MOCK_PREVIOUS_CODINGS.map(coding => <button key={coding.glCode} onClick={() => setSelectedCode(coding.glCode)} className={`w-full text-left px-4 py-3 rounded-lg border transition-colors ${selectedCode === coding.glCode ? 'border-purple-500 bg-purple-50' : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'}`} data-id="element-6778">
                <div className="flex items-start justify-between" data-id="element-6779">
                  <div className="flex-1" data-id="element-6780">
                    <div className="flex items-center gap-2 mb-1" data-id="element-6781">
                      <code className="text-sm font-mono font-medium text-gray-900" data-id="element-6782">
                        {coding.glCode}
                      </code>
                      <span className="px-2 py-0.5 bg-gray-100 rounded text-xs text-gray-600" data-id="element-6783">
                        Used {coding.useCount}x
                      </span>
                    </div>
                    <p className="text-sm text-gray-600" data-id="element-6784">
                      {coding.description}
                    </p>
                    <div className="flex items-center gap-2 mt-2 text-xs text-gray-500" data-id="element-6785">
                      <ClockIcon className="w-3 h-3" data-id="element-6786" />
                      <span data-id="element-6787">Last used: {coding.usedDate}</span>
                      <span data-id="element-6788">•</span>
                      <span data-id="element-6789">{coding.invoiceNumber}</span>
                    </div>
                  </div>
                  {selectedCode === coding.glCode && <CheckIcon className="w-5 h-5 text-purple-600 flex-shrink-0" data-id="element-6790" />}
                </div>
              </button>)}
            {MOCK_PREVIOUS_CODINGS.length === 0 && <div className="text-center py-8 text-gray-500" data-id="element-6791">
                <HistoryIcon className="w-8 h-8 mx-auto mb-2 text-gray-300" data-id="element-6792" />
                <p className="text-sm" data-id="element-6793">No previous coding history found</p>
              </div>}
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-end gap-3" data-id="element-6794">
          <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-6795">
            Cancel
          </button>
          <button onClick={handleApply} disabled={!selectedCode} className="px-4 py-2 text-sm font-medium text-white bg-purple-600 rounded-lg hover:bg-purple-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed" data-id="element-6796">
            Apply to All {lineItemCount} Lines
          </button>
        </div>
      </div>
    </div>;
}